import React from 'react'

function Function() {
    return (
        <span className='cs-data-function'>Function</span>
    )
}

export { Function }